import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src="./marcus.jpg" alt="logo" />
        <p>
          Marcus Sjölin
          <hr />
          Security Advisor Consultant<br />
          Technical Leadership<br />
          Crypto Security, Privacy & Decentralisation Advisor
          <hr />
          Gothenburg, Sweden
        </p>
      </header>
    </div>
  );
}

export default App;
